const payload = {
	"data": {
		"type": "back-in-stock-subscription",
		"attributes": {
			"profile": {
				"data": {
					"type": "profile",
					"attributes": {
						"email": "test@emit.digital",
					}
				}
			},
			"channels": ["EMAIL"],
		},
		"relationships": {
			"variant": {
				"data": {
					"type": "catalog-variant",
					"id": "$shopify:::$default:::54044685369612"

				}
			}
		}
	}
}

var requestOptions = {
	method: 'POST',
	headers: {
		"Content-Type": "application/json",
		"revision":"2024-06-15"
	},
	body: JSON.stringify(payload),
};

// fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=W5YGHr",requestOptions)
// 	.then(result => console.log(result))
// 	.catch(error => console.log('error', error));


if (!customElements.get('back-in-stock')) {
	customElements.define('back-in-stock', class BackInStock extends HTMLElement {
		constructor() {
			super();
			this.form = this.querySelector('form');
			this.form.addEventListener('submit', this.formSubmit.bind(this)); // submit event
		}

		formSubmit(evt) {
			evt.preventDefault();
			const sendForm = validateForm(this.form);
			console.log(sendForm);
			if(sendForm){
				this.sendRequest();
			}
		}
		sendRequest(){
			let variantId = document.querySelector('.js-main-product-form-wrapper form input[name="id"]').value;
			let email = this.form.querySelector('input[name="email"]').value;
			const requestData = {
				"data": {
					"type": "back-in-stock-subscription",
					"attributes": {
						"profile": {
							"data": {
								"type": "profile",
								"attributes": {
									"email": email,
								}
							}
						},
						"channels": ["EMAIL"],
					},
					"relationships": {
						"variant": {
							"data": {
								"type": "catalog-variant",
								"id": `$shopify:::$default:::${variantId}`

							}
						}
					}
				}
			}
			const requestConfig = {
				method: 'POST',
				headers: {
					"Content-Type": "application/json",
					"revision":"2024-06-15"
				},
				body: JSON.stringify(requestData),
			};

			fetch(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${atob(window.klaviyoData.klaviyo_company_id)}`, requestConfig)
				.then((response) => {
					if (response.status != 202) {
						// Error function
						this.errorMessage(response)
						return;
					}
					// Succses function
					this.succses()
				})
				.catch((error) => {
					console.log(error);
				});
		}
		errorMessage(resp) {
			console.log(resp)
			console.log(resp.description);
		}
		succses() {
			const _this = this;
			console.log('success')
			this.form.style.display = 'none'
			if(this.querySelector('.back-in-stock-popup-text')){
				this.querySelector('.back-in-stock-popup-text').innerHTML = window.klaviyoData.back_in_stock_success
				this.querySelector('.back-in-stock-popup-text').style.margin = 0;
			}
			setTimeout(function (){
				_this.form.removeAttribute('style')
				if(_this.querySelector('.back-in-stock-popup-text')){
					_this.querySelector('.back-in-stock-popup-text').innerHTML = window.klaviyoData.back_in_stock_text
					_this.querySelector('.back-in-stock-popup-text').removeAttribute('style')
				}
			},10000)
		}
	});
}
